<template>
  <div class="fixed top-safe-offset-4 right-safe-offset-4 z-50 space-y-2">
    <transition-group
      name="toast"
      tag="div"
      class="space-y-2"
    >
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        :type="toast.type"
        :title="toast.title"
        :message="toast.message"
        :duration="toast.duration"
        :persistent="toast.persistent"
        @dismiss="() => removeToast(toast.id)"
      />
    </transition-group>
  </div>
</template>

<script setup>
import { useToast } from '@/composables/useToast'
import Toast from './Toast.vue'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style> 